import { render } from "./SectionSupport.vue?vue&type=template&id=0173f438"
import script from "./SectionSupport.vue?vue&type=script&lang=js"
export * from "./SectionSupport.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__